import { GOOGLE_MAPS_API_KEY } from '../config';
import React, { useEffect, useRef, useState } from 'react';
import { processChineseAddress, processDefaultAddress, processIndianAddress, processJapaneseAddress, processKoreanAddress } from './GoogleAddressFormat';
import { InputGroup } from 'react-bootstrap';
import { FaFacebookF, FaSearch } from 'react-icons/fa';

const GoogleAddressAutocomplete = ({ onPlaceSelected }) => {
    const inputRef = useRef(null);
    const autocompleteRef = useRef(null);
    const [isLoaded, setIsLoaded] = useState(false);

    // Load the Google Maps API script
    useEffect(() => {
        // Don't load the script if it's already there
        if (window.google?.maps?.places) {
            setIsLoaded(true);
            return;
        }

        const googleMapScript = document.createElement('script');
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
        googleMapScript.async = true;
        googleMapScript.defer = true;

        googleMapScript.addEventListener('load', () => {
            setIsLoaded(true);
        });

        document.body.appendChild(googleMapScript);

        return () => {
            // Clean up the script when component unmounts
            document.body.removeChild(googleMapScript);
        };
    }, []);

    // Initialize autocomplete once the API is loaded
    useEffect(() => {
        if (!isLoaded || !inputRef.current) return;

        autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
            // You can customize these options as needed
            types: ['address'],
            //componentRestrictions: { country: 'us' } // Remove or change this for different countries
        });

        // Add a listener for place changes
        autocompleteRef.current.addListener('place_changed', () => {
            const place = autocompleteRef.current.getPlace();
            if (onPlaceSelected && place) {
                selectedAddressCountryWise(place)
                // onPlaceSelected(place);
                // Clear the input field after selection
                if (inputRef.current) {
                    inputRef.current.value = '';
                }
            }
        });

        return () => {
            // Clean up listener when component unmounts
            window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
        };
    }, [isLoaded, onPlaceSelected]);

    const selectedAddressCountryWise = (location) => {
        const google_id = location.id;
        const google_place_id = location.place_id;
        const address = location.formatted_address;
        const addresses = location.address_components;
        let latitute = location?.geometry?.location?.lat((e) => e.Scopes[0].e);
        let longitude = location?.geometry?.location?.lng((e) => e.Scopes[0].f);

        let addressComponents = {
            address: address,
            address_line_1: '',
            address_line_2: '',
            city: '',
            state: '',
            country: '',
            country_code: '',
            zipcode: '',
            latitute,
            longitude,
            google_id,
            google_place_id,
        };

        // Helper function to extract components by type
        const getComponentByType = (type) => {
            return addresses.find(component => component.types.includes(type));
        };

        const countryComponent = getComponentByType('country');
        if (countryComponent) {
            addressComponents.country = countryComponent.long_name;
            addressComponents.country_code = countryComponent.short_name;
        }

        switch (addressComponents.country_code) {
            case 'JP': // Japan
                processJapaneseAddress(addresses, addressComponents);
                break;
            case 'KR': // South Korea
                processKoreanAddress(addresses, addressComponents);
                break;
            case 'CN': // China
                processChineseAddress(addresses, addressComponents);
                break;
            case 'IN': // India
                processIndianAddress(addresses, addressComponents);
                break;
            default:
                // Western/Default format
                processDefaultAddress(addresses, addressComponents);
        }
        return onPlaceSelected(addressComponents);
    }

    return (
        <div className='search-input position-relative'>
            <input
                ref={inputRef}
                type="text"
                onFocus={(e) => e.target.setAttribute("autoComplete", "none")}
                placeholder="Enter an address"
                className="form-control"
            />
            {/*  <InputGroup.Text> */}
            <FaSearch />
            {/*  </InputGroup.Text> */}
        </div>
    );
};
export default GoogleAddressAutocomplete;